import React from 'react';
import PropTypes from 'prop-types';

import BrandLogo from './BrandLogo';

const propTypes = {
    onClickBrandLogo: PropTypes.func,
    children: PropTypes.node,
    leftChildren: PropTypes.node,
    logoLinkDisable: PropTypes.bool,
    useMinLogo: PropTypes.bool,
    hideLogo: PropTypes.bool,
    customLogo: PropTypes.object,
};

const defaultProps = {
    onClickBrandLogo: () => {},
    children: null,
    leftChildren: null,
    logoLinkDisable: false,
    useMinLogo: false,
    hideLogo: false,
    customLogo: null,
};

function TopNav(props) {
    return (
        <header className="top-navbar db3TopNav">
            <div className="container-fluid">
                <div className="nav-left">
                    {props.leftChildren}
                </div>
                <div className="nav-center">
                    {(!props.hideLogo) &&
                        <BrandLogo
                            onClick={props.onClickBrandLogo}
                            logoLinkDisable={props.logoLinkDisable}
                            useMinLogo={props.useMinLogo}
                            customLogo={props.customLogo}
                        />
                    }
                </div>
                <div className="nav-right">
                    {props.children}
                </div>
            </div>
        </header>
    );
}

TopNav.propTypes = propTypes;
TopNav.defaultProps = defaultProps;

export default TopNav;
